import React, { useRef, useState } from 'react';
import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';
import MemoDatePicker from '@components/summary-panel/SummaryContainer/DatePickers';
import moment from 'moment';

const RangePickerComponent = ({
  interval,
  onChange,
  placement,
  shortcuts,
  showCustom = true,
  durationLimit = 15,
  calenderBoundry = undefined,
}: {
  interval?: string;
  placement?: string;
  onChange?: (value: string) => void;
  shortcuts?: any;
  showCustom?: boolean;
  durationLimit?: number;
  calenderBoundry?: { start_time: number; end_time: number } | undefined;
}) => {
  const summaryDatePickerRef = useRef<any>(null);
  const comparisonDatePickerRef = useRef<any>(null);
  const [from, to]: any = interval?.split('/');
  const isToRecent = to && moment().diff(moment(to), 'minutes') < 5;
  const [shortcut, setShortcut] = useState(isToRecent ? 'past 24 hours' : 'custom');
  const { userInfo } = useInitialInfoStore();
  const durationAllowed = userInfo.data_access_months || 13;

  const hasIntervalChanged = (newInterval) => {
    try {
      if (newInterval[0].isSame(moment(from)) && newInterval[1].isSame(moment(to))) {
        return false;
      }
    } catch (err) {}
    return true;
  };

  const validateUpdateInterval = (dates, short) => {
    // check if summary interval changed before triggering redux action
    // as there are multiple listeners
    if (hasIntervalChanged(dates)) {
      setShortcut(short);
      onChange?.([dates[0]?.format(), dates[1]?.format()].join('/'));
    }
  };
  return (
    <MemoDatePicker
      key={interval}
      interval={{ from, to, shortcut }}
      comparisonInterval={{ from: '', to: '', shortcut: '' }}
      setComparisonUnavailable={() => {}}
      setComparisonInterval={() => {}}
      dod={false}
      summaryDatePickerRef={summaryDatePickerRef}
      validateUpdateInterval={validateUpdateInterval}
      comparisonDatePickerRef={comparisonDatePickerRef}
      durationAllowed={durationAllowed}
      durationLimit={durationLimit}
      placement={placement}
      shortcuts={shortcuts}
      showCustom={showCustom}
      calenderBoundry={calenderBoundry}
    />
  );
};

export default RangePickerComponent;
